import { Loader2 } from 'lucide-react';

export const PageLoader = () => (
  <div className="flex items-center justify-center h-[50vh] w-full">
    <Loader2 className="w-8 h-8 text-blue-500 animate-spin" />
  </div>
);